import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { DesignSystemToken } from 'designSystem/types';
import { toggleDsPick } from 'redux/mode/actions';
import { sortTokens } from './tokenUtil';
import { TokenCard } from './TokenCard';
import * as S from './styles';

interface TokenGridProps {
	tokens: DesignSystemToken[];
}

// Renders a grid of TokenCards sorted alphabetically by name
const TokenGrid = ({ tokens }: TokenGridProps) => {
	const dispatch = useDispatch();
	const sorted = useMemo(() => sortTokens(tokens, 'name', 'asc'), [tokens]);

	return (
		<S.TokenGrid>
			{sorted.map((token) => (
				<TokenCard
					key={token.id}
					token={token}
					onClick={() =>
						dispatch(toggleDsPick({ kind: 'token', cssVariable: token.cssVariable }))
					}
				/>
			))}
		</S.TokenGrid>
	);
};

export default TokenGrid;
